<template>
    <div class="full-wdith" v-loading="loading">
        <div>
            <div class="keyword-part">
                <el-input
                    v-model="keyword"
                    class="w-50 m-2"
                    size="large"
                    :placeholder="`${i18n.tkey('lang_search_text')}...`"
                    :prefix-icon="Search"
                    clearable
                    @change="changeKeyword"
                    style="width: calc(100% - 6em); display: inline-block"
                />
            </div>
        </div>

        <div style="margin-top: 20px">
            <userListBackstage
                :list="dataList"
                @clickBtn="actionCallback"
            />
        </div>

        <div>
            <PaginationComponent
                :pageObj="pageObj"
                @goPage="changePage"
            />
        </div>
    </div>
</template>

<script setup>

import {inject, ref, toRef, onBeforeMount} from "vue";
import PaginationComponent from "@/components/shopopee/common/paginationComponent.vue";
import UserListBackstage from "@/components/shopopee/backstage/user/userListBackstage.vue";
import {useUserinfo} from "@/stores/userinfo";
import {Search} from "@element-plus/icons-vue";
import myUtil from "@/util/util";
import userApi from "@/request/userApi";

const userInfoRef = toRef(useUserinfo())
const i18n = inject("i18n")
const loading = ref(false)

const dataList = ref([])

const pageNum = ref(1)
const pageSize = ref(10)
const pageObj = ref({})
const keyword = ref(null)

function getDataList(){
    loading.value = true

    const request = userApi.getMemberByPageForAdmin
    const params = request.getParams()

    params.membergroup = userInfoRef.value.companycode
    params.name = keyword.value
    params.pageNum = pageNum.value
    params.pageSize = pageSize.value

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200) {
            const obj = res.detail

            pageObj.value = obj

            dataList.value = obj.list

        }
    })

}

function changeKeyword() {
    pageNum.value = 1

    getDataList()
}

function changePage(num) {
    pageNum.value = num
    getDataList()
}

function actionCallback(name, obj) {
    switch (name) {
        case "logoff":
            logoffConfirm(obj)
            break
    }
}

function logoffConfirm(obj){
    myUtil.confirmWarning(i18n.tkey("lang_logooff_confirm_2"), () => {
        myUtil.confirmWarning(i18n.tkey("lang_logooff_confirm_1"), () => {
            logoffUser(obj)
        })
    })
}

function logoffUser(obj){
    const request = userApi.logoffMember
    const params = request.getParams()

    params.id = obj.id

    request.send(params, (res) => {
        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_operate_success"))
            getDataList()
        }else{
            myUtil.alertError(res.msg)
        }
    })

}

onBeforeMount(() => {
    getDataList()
})

</script>

<style scoped>
.full-wdith {
    width: 100%;
}

.keyword-part {
    text-align: center;
}
</style>